// extracted by mini-css-extract-plugin
module.exports = {"qrCodeContainer":"qrcode-container__qrCodeContainer___nlS-A","qrCodeWrapper":"qrcode-container__qrCodeWrapper___HYzOi"};